import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { getAssetPageTabDefault } from '../../../helpers/util'
import useActiveTab from '../../../hooks/useActiveTab'
import clsx from 'clsx'
import ToolTip from '../../Tooltip/Tooltip'

const CellLink = ({
    text,
    to,
    page = '',
    activeTab = '',
    disableLink = false,
    isOffline = false,
    needRelative = false,
    translate,
}) => {
    const [isHovered, setIsHovered] = useState(false)
    const tabs = getAssetPageTabDefault()

    const { toggleActiveTab } = useActiveTab(page, tabs)

    const handleTabClick = event => {
        if (disableLink) {
            event.preventDefault()
            return
        }
        if (activeTab) {
            toggleActiveTab(activeTab)
        }
    }

    return (
        <div
            className={clsx('inline-block', needRelative && 'relative')}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Link
                to={to}
                className={clsx(
                    'text-base font-normal truncate max-w-min',
                    disableLink
                        ? 'cursor-not-allowed text-gray-400'
                        : 'text-links hover:underline',
                )}
                onClick={handleTabClick}
            >
                {text}
            </Link>
            {isHovered && disableLink && isOffline && (
                <ToolTip
                    position="right"
                    text="This feature requires an internet connection"
                    translate={translate}
                />
            )}
        </div>
    )
}

CellLink.propTypes = {
    text: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.any,
    ]),
    to: PropTypes.string,
    page: PropTypes.string,
    activeTab: PropTypes.string,
    disableLink: PropTypes.bool,
    isOffline: PropTypes.bool,
    needRelative: PropTypes.bool,
    translate: PropTypes.string,
}

export default CellLink
